// Ported from https://gitlab.cloud.bukalapak.io/buka20/marketplace/static-fragment/fragments/internal-sentinel/-/blob/master/utils/vp-receipt.ts

const ReceiptComponentTypes = {
  Column: 'TYPE_COLUMN',
  Divider: 'TYPE_DIVIDER',
  Space: 'TYPE_SPACE',
  Note: 'TYPE_NOTE',
  ColumnNote: 'TYPE_COLUMN_NOTE',
  Highlight: 'TYPE_HIGHLIGHT',
  CrossSelling: 'TYPE_CROSS_SELLING',
  TitleSmallAlignLeft: 'TYPE_TITLE_SMALL_ALIGN_LEFT',
  TextSmallAlignLeft: 'TYPE_TEXT_SMALL_ALIGN_LEFT',
};

const DEFAULT_MAX_LINES = 2147483647;

const receiptBuilder = {
  createSpace() {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: '',
      subtitle: '',
      type: ReceiptComponentTypes.Space,
      value: '',
    };
  },
  createDivider() {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: '',
      subtitle: '',
      type: ReceiptComponentTypes.Divider,
      value: '',
    };
  },
  createColumn(label, value) {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: label,
      subtitle: '',
      type: ReceiptComponentTypes.Column,
      value,
    };
  },
  createNote(value) {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: '',
      subtitle: '',
      type: ReceiptComponentTypes.Note,
      value,
    };
  },
  createColumnNote(value) {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: '',
      subtitle: '',
      type: ReceiptComponentTypes.ColumnNote,
      value,
    };
  },
  createHighlight(name, value) {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name,
      subtitle: '',
      type: ReceiptComponentTypes.Highlight,
      value,
    };
  },
  createCrossSelling(value, previewValue, icon) {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: '',
      subtitle: '',
      type: ReceiptComponentTypes.CrossSelling,
      value,
      previewValue,
      icon,
    };
  },
  createTitleSmallAlignLeft(value) {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: '',
      subtitle: '',
      type: ReceiptComponentTypes.TitleSmallAlignLeft,
      value,
    };
  },
  createTextSmallAlignLeft(value) {
    return {
      maxLines: DEFAULT_MAX_LINES,
      name: '',
      subtitle: '',
      type: ReceiptComponentTypes.TextSmallAlignLeft,
      value,
    };
  },
};

module.exports = {
  ReceiptComponentTypes,
  DEFAULT_MAX_LINES,
  receiptBuilder,
};
